import React, { useContext } from "react"
import AuthState, { AuthContext } from "./auth/authState"
import EventsState, { EventsContext } from "./events/eventsState"
import NotificationState, { NotificationContext } from "./notification/notificationState"
import LanguageState, { LanguageContext } from "./language/languageState"
import ContactState, { ContactContext } from "./contact/contactState"
import CookiesState, { CookiesContext } from "./cookies/cookiesState"
import NewsState, { NewsContext } from "./news/newsState"
import StatisticsState, { StatisticsContext } from "./statisticsState/statisticsState"

const ContextWrapper = ({ children }) => {
  
  return (
    <LanguageState>
      <CookiesState>
        <NotificationState>
          <ContactState>
            <AuthState>
              <EventsState>
                <NewsState>
                  <StatisticsState>
                    {children}
                  </StatisticsState>
                </NewsState>
              </EventsState>
            </AuthState>
          </ContactState>
        </NotificationState>
      </CookiesState>
    </LanguageState>
  )
}

export {
  AuthState,
  AuthContext,
  EventsState,
  EventsContext,
  NotificationState,
  NotificationContext,
  LanguageState,
  LanguageContext,
  ContactState,
  ContactContext,
  CookiesState,
  CookiesContext,
  NewsState,
  NewsContext,
  StatisticsState,
  StatisticsContext,
}

export default ContextWrapper
